import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    reportTitle:{
        fontSize: 10,
        marginTop: 5,
        fontFamily: 'Helvetica-Bold',
        textIndent: '5px'
    },
    container:{
        paddingTop: '3px',
        paddingLeft: '3px',
        paddingRight: '3px',
        height:'20px',
        fontSize: 10,
        flexDirection: 'row',
        fontWeight: 'normal',
        border: '1px solid #000000',
        borderRadius: '3px'
    },
    text:{
        fontSize: 10
    }
});

const ProposalPayment = ({invoice}) => (  
   <View style={{flexDirection: 'row'}}>
        <View style={{width:'49%', 'marginRight':'1%'}}>
            <Text style={styles.reportTitle}>Condição de Pagamento</Text>
            <View style={styles.container}>
                <Text>{invoice?.condicaoComercial?.paymentCondiction?.name}</Text>
            </View>
        </View>
        <View style={{width:'49%', 'marginLeft':'1%'}}>
            <Text style={styles.reportTitle}>Forma de Pagamento</Text>
            <View style={styles.container}>
                <Text>{invoice?.condicaoComercial?.paymentForm?.name}</Text>
            </View>
        </View>
   </View>
);
  
export default ProposalPayment